<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-学生信息-修改
    -->
    <el-dialog
    title="修改学生信息"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改学生信息</div>
    <!-- 全分类选择 -->
    <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为学生信息标题</el-button>
      </el-form-item> -->

  <el-form-item label="学生姓名" prop="name">
    <el-input v-model="form.name" placeholder="请输入学生姓名" class="max-w460"></el-input>
  </el-form-item>
  
  <el-form-item label="性别" prop="sex">
    <el-select v-model="form.sex" placeholder="请选择性别" class="max-w460">
      <el-option label="男" value=0></el-option>
      <el-option label="女" value=1></el-option>
    </el-select>
  </el-form-item>
  
<el-form-item label="学校" prop="school">
  <el-select 
    v-model="form.school" 
    placeholder="请选择学校" 
    class="max-w460"
    filterable
  >
    <el-option
      v-for="item in school"
      :key="item.school_management_id"
      :label="item.name"
      :value="item.school_management_id"
    ></el-option>
  </el-select>
</el-form-item>

  <el-form-item label="班级" prop="class">
    <el-input v-model="form.class" placeholder="请输入班级" class="max-w460"></el-input>
  </el-form-item>
  
  <el-form-item label="身高(cm)" prop="height">
    <el-input 
      v-model.number="form.height" 
      type="number"
      placeholder="请输入身高" 
      class="max-w460">
      <template slot="append">cm</template>
    </el-input>
  </el-form-item>
  
  <el-form-item label="体重(kg)" prop="weight">
    <el-input 
      v-model.number="form.weight" 
      type="number"
      placeholder="请输入体重" 
      class="max-w460">
      <template slot="append">kg</template>
    </el-input>
  </el-form-item>
  
<el-form-item label="尺码" prop="size">
  <el-select 
    v-model="form.size" 
    placeholder="请选择尺码" 
    class="max-w460"
  >
    <el-option
      v-for="item in size"
      :key="item.size_id"
      :label="item.name"
      :value="item.size_id"
    ></el-option>
  </el-select>
</el-form-item>
  
  <el-form-item label="排序" prop="sort">
    <el-input 
      v-model.number="form.sort" 
      type="number"
      placeholder="请输入排序" 
      class="max-w460"></el-input>
  </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Student_infoApi from '@/api/student_info.js';
import School_managementApi from '@/api/school_management.js';
import SizeApi from '@/api/size.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
       form: {
      name: '',
      sex: '',
      school: '',
      class: '',
      height: null,
      weight: null,
      size: '',
      sort: 50,
      image: [],
      intro: "",
      bannar: []
    },
      loading: false,
      /*验证规则*/
        rules: {
      name: [
        { required: true, message: '请输入学生姓名', trigger: 'blur' },
        { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
      ],
      sex: [
        { required: true, message: '请选择性别', trigger: 'change' }
      ],
      sort: [
        { type: 'number', message: '排序必须为数字值', trigger: 'blur' }
      ]
    },
      dialogVisible:false,
      school:[],
      size:[],
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getSchool();  
    this.getSize(); 
  },
  props: ["open_add","student_info_id"],
  methods: {
    // closeDialogFunc(e) {
    //   console.log(e)
    //   let self = this;
    //   self.iscategorya = false;
    //   if (e.type === 'success') {
    //     let arr = [];
    //     for (let i = 0; i < e.params.length; i++) {
    //       let item = e.params[i];
    //       arr = {
    //         name: item.name,
    //         categorya_id: item.categorya_id,
    //         image: item.image,
    //       };
    //     }
    //     self.form.categorya = arr;
    
    //   }
    // },
 getSchool() {
  return new Promise((resolve) => {
    School_managementApi.list()
      .then(data => {
        this.school = data.data.list.data;
        resolve();
      })
      .catch(error => {
        console.error("获取学校列表失败:", error);
        resolve();
      });
  });
},

getSize() {
  return new Promise((resolve) => {
    SizeApi.list()
      .then(data => {
        this.size = data.data.list.data;
        resolve();
      })
      .catch(error => {
        console.error("获取尺码列表失败:", error);
        resolve();
      });
  });
},
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
getDetail() {
  let self = this;
  // 先确保学校和尺码列表加载完成
  Promise.all([
    this.getSchool(),
    this.getSize()
  ]).then(() => {
    // 再加载学生详情
    Student_infoApi.detail({student_info_id: self.student_info_id}, true)
      .then(res => {
        // 确保数据类型一致（字符串转数字）
          const schoolObj = this.school.find(item => 
          item.school_management_id == res.data.school
        );
        
        const sizeObj = this.size.find(item => 
          item.size_id == res.data.size
        );
        self.form = {
          ...res.data,
          school: schoolObj ? schoolObj.name : '未知学校',
          size:sizeObj ? sizeObj.name : '未知尺码',
          sex: Number(res.data.sex)===0?'男':'女'
        };
        
        self.ueditor.text = self.form.intro;
        self.isImg = true;
        self.loading = false;
        
        if(!self.form.bannar) self.form.bannar = [];
        if(!self.form.image) self.form.image = [];
        
        // 强制更新视图（确保下拉框重新渲染）
        self.$nextTick(() => {
          self.$forceUpdate();
        });
      })
      .catch(error => {
        console.error("获取学生详情失败:", error);
      });
  });
 },
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      
      form.student_info_id = self.student_info_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Student_infoApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/student_info/index/part/edit.vue